import { Button } from '@/components/Button/Button';
import { useAppTranslation } from '@/hooks/useAppTranslation';
import { Ionicons } from '@expo/vector-icons';
import { useLocalSearchParams, useRouter, useSegments } from 'expo-router';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { H2, SizableText, YStack, getTokens } from 'tamagui';
import { appConfig as tamaguiConfig } from 'tamagui.config';

export default function ReportRraRequestSuccessScreen(): React.ReactNode {
  const { t } = useAppTranslation();
  const router = useRouter();
  const { reportId } = useLocalSearchParams<{
    reportId?: string;
  }>();
  const segments = useSegments() as string[];
  const insets = useSafeAreaInsets();
  const uiTokens = getTokens();
  const isBoardRoute = segments.includes('board');

  const handleBackToReport = (): void => {
    if (!reportId) {
      router.replace('/(tabs)/reports');
      return;
    }

    if (isBoardRoute) {
      router.replace({
        pathname: '/(tabs)/board/reports/[reportId]',
        params: { reportId },
      });
      return;
    }

    router.replace({
      pathname: '/(tabs)/reports/[reportId]',
      params: { reportId },
    });
    return;
  };

  const iconSize = uiTokens.size.$3.val;
  const iconContainerSize = uiTokens.size.$5.val;

  return (
    <YStack
      flex={1}
      paddingHorizontal="$true"
      paddingTop={insets.top + uiTokens.space.$4.val}
      paddingBottom={Math.max(insets.bottom, uiTokens.space.$4.val)}
    >
      <YStack flex={1} alignItems="center" justifyContent="center" gap="$3">
        <YStack
          width={iconContainerSize}
          height={iconContainerSize}
          borderRadius="$circle"
          backgroundColor="$successBg"
          alignItems="center"
          justifyContent="center"
        >
          <Ionicons
            name="checkmark"
            size={iconSize}
            color={tamaguiConfig.tokens?.color?.success?.val}
          />
        </YStack>

        <YStack alignItems="center" gap="$2">
          <H2 textAlign="center">
            {t('reportDetail.rraRequestSuccess.title')}
          </H2>
          <SizableText size="$2" textAlign="center" color="$secondary75">
            {t('reportDetail.rraRequestSuccess.subtitle')}
          </SizableText>
        </YStack>
      </YStack>

      <Button
        title={t('reportDetail.rraRequestSuccess.validateButton')}
        onPress={handleBackToReport}
        width="100%"
      />
    </YStack>
  );
}
